"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var constants = {
  defaultAPIVersion: 'v2',
  defaultHost: 'https://api.openrouteservice.org',
  apiKeyPropName: 'api_key',
  hostPropName: 'host',
  missingAPIKeyMsg: 'Please add your openrouteservice api_key..',
  useAPIV2Msg: 'Please use ORS API v2',
  baseUrlConstituents: ['host', 'service', 'api_version', 'mime_type'],
  propNames: {
    apiKey: 'api_key',
    host: 'host',
    service: 'service',
    apiVersion: 'api_version',
    mimeType: 'mime_type',
    profile: 'profile',
    format: 'format',
    timeout: 'timeout'
  }
};
var _default = constants;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/openrouteservice-js/lib/constants.js
// module id = 165
// module chunks = 0